import {
	Button,
	Grid,
	makeStyles,
	TextareaAutosize,
	TextField,
	Typography,
} from "@material-ui/core";
import React, { useEffect, useRef } from "react";
import BackendTemplateItem from "../component/backend-gencode/BackendTemplateItem";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs";
import SyntaxHighlighter from "react-syntax-highlighter";
import { materialDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { a11yDark } from "react-syntax-highlighter/dist/esm/styles/hljs";

// import { highlight, languages } from "prismjs/components/prism-core";
import { useState } from "react";
import InsertVariable from "../component/backend-gencode/InsertVariable";
import { variableTemplate } from "../model/setup-sequelize/EVariableTemplate";
import _ from "lodash";
import { useFormik } from "formik";
import { FileCodeBackend } from "../model/model/gencode/FileCodeBackend";
import {
	backendTemplateController,
	fileCodeBackendTemplateController,
} from "../controller";
import { useParams } from "react-router";
import { useCrudHook } from "../helpers/CrudHook";
import PopUpConfirm from "../component/genaral-component/PopupConfirm";
import { useHistory } from "react-router";

const useStyle = makeStyles((theme) => ({
	editor: {
		// height: 200,
		flex: 1,
		// maxWidth : "100%",
		background: "rgb(43, 43, 43)",
		"& pre": {
			background: "none !important",
			padding: "0px !important",
			margin: "0px !important",
			marginTop: "0px !important",
			marginLeft: "1px !important",
			outline: "none !important",
			border: "none !important",
			"& :focus": {},
		},
		border: "none",
	},
	preview: {
		flex: 1,
	},
	code: {
		background: "none",
	},
	input: {
		marginTop: 10,
	},
	variables: {
		padding: 10,
		"& button": {
			margin: 10,
		},
	},
}));

export default function SettingTemplateBackendDetail() {
	const history = useHistory();
	const { templateId, id } = useParams<{ templateId: string; id: string }>();
	const crud = useCrudHook({
		controller: fileCodeBackendTemplateController,
	});
	const formik = useFormik<FileCodeBackend>({
		initialValues: {},
		onSubmit: () => {
			fileCodeBackendTemplateController
				.save(formik.values)
				.then((res) => {
					history.push(
						`/setting-template-detail/${templateId}/${res.id || ""}`
					);
				});
		},
	});
	const currenIndexPoint = useRef<number>(0);
	const classes = useStyle();
	const handleSubmit = () => {
		formik.handleSubmit();
	};
	const insertCode = (value: string) => {
		let [sub, remain] = [
			formik.values.template?.substring(0, currenIndexPoint.current),
			formik.values.template?.substring(currenIndexPoint.current),
		];
		formik.setValues({
			...formik.values,
			template: `${sub}{${value}}${remain}`,
		});
	};
	const preview = (code: string): string => {
		variableTemplate.forEach((variable) => {
			const varName = "{" + variable.variable + "}";
			code = code.replace(
				new RegExp(varName, "g"),
				variable.preview || varName
			);
		});
		return code;
	};
	useEffect(() => {
		fileCodeBackendTemplateController.get(id).then((res) => {
			formik.setValues({
				...res,
				template:
					res?.template ||
					`
	`,
				templateId: templateId,
			});
		});
	}, []);
	return (
		<Grid container>
			<PopUpConfirm
				isDisplay={crud.isShowConfirm}
				onCancel={crud.onCancelConfirm}
				onDelete={async () => {
					await crud.onDelete(crud.itemSelected);
					history.push(`/setting-template`);
				}}
			/>
			<Grid container justify="space-between">
				<Typography variant="h3">Setting file</Typography>
				<Button
					variant="contained"
					color="primary"
					onClick={(e) => {
						crud.onConfirm(formik.values);
					}}
				>
					Delete
				</Button>
				<Button
					variant="contained"
					color="primary"
					onClick={(e) => {
						handleSubmit();
					}}
				>
					Save
				</Button>
			</Grid>
			<Grid container direction="column" md={6}>
				<TextField
					className={classes.input}
					label="Mô tả"
					value={formik.values.desc}
					name="desc"
					onChange={formik.handleChange}
				></TextField>
				<TextField
					className={classes.input}
					label="Tên file"
					value={formik.values.name}
					onChange={formik.handleChange}
					name="name"
				></TextField>
				<TextField
					className={classes.input}
					value={formik.values.path}
					onChange={formik.handleChange}
					name="path"
					label="Đường dẫn file"
				></TextField>
			</Grid>
			<Grid
				container
				style={{
					margin: 20,
				}}
			>
				<Grid md={2}>
					<Grid
						container
						direction={"column"}
						// className={classes.variables}
					>
						<InsertVariable
							onClick={(e) => {
								insertCode(e);
								console.log(e);
							}}
							variables={variableTemplate.map(
								(item) => item.variable
							)}
						></InsertVariable>
					</Grid>
				</Grid>
				<Grid className={classes.editor}>
					<TextareaAutosize
						value={formik.values.template || ""}
						onChange={(e) => {
							formik.setValues({
								...formik.values,
								template: e.target.value,
							});
						}}
						onBlur={(e: any) => {
							currenIndexPoint.current = e.target
								.selectionStart as number;
						}}
						style={{
							fontFamily: '"Fira code", "Fira Mono", monospace',
							width : "100%"
							// fontSize: 12,
							// caretColor: "white",
							// color: "none",
						}}
						placeholder="Empty"
					/>

					{/* <Editor
						value={formik.values.template || ""}
						// className={classes.editor}
						onValueChange={(code) => {
							formik.setValues({
								...formik.values,
								template: code,
							});
						}}
						onBlur={(e: any) => {
							currenIndexPoint.current = e.target
								.selectionStart as number;
						}}
						highlight={(code) => {
							return <div style ={{color : "white"}}>{code}</div>
							// return (
							// 	<SyntaxHighlighter
							// 		language="js"
							// 		style={a11yDark}
							// 	>
							// 		{code}
							// 	</SyntaxHighlighter>
							// );
						}}
						padding={10}
						style={{
							fontFamily: '"Fira code", "Fira Mono", monospace',
							// fontSize: 12,
							// caretColor: "white",
							// color: "none",
						}}
					/> */}
				</Grid>
				<Grid container>
					<SyntaxHighlighter
						language="js"
						style={a11yDark}
						className={classes.preview}
					>
						{preview(formik.values.template || "")}
					</SyntaxHighlighter>
				</Grid>
			</Grid>
		</Grid>
	);
}
